<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs8>
                <v-card>
                    <v-layout row>
                        <v-layout column class="ma-1 px-3">
                            <v-card-title class="pb-1 pt-2" primary-title>
                                <div>
                                    <div v-if="account.nonUTA">
                                        <v-layout
                                            row
                                            align-center
                                            class="pl-2 py-2"
                                        >
                                            <h3 class="headline my-0">
                                                Account ID:
                                                {{ account.accountID }}
                                            </h3>
                                            <div
                                                class="font-weight-medium ml-2 text-info"
                                            >
                                                Non UTA
                                            </div>
                                            <v-card-actions>
                                                <v-btn
                                                    color="success"
                                                    outline
                                                    small
                                                    @click="editAccount"
                                                    >Edit Account</v-btn
                                                >
                                            </v-card-actions>
                                        </v-layout>
                                    </div>
                                    <h3
                                        class="headline my-0"
                                        v-if="!account.nonUTA"
                                    >
                                        Account ID:
                                        {{ account.accountID }}
                                    </h3>
                                </div>
                            </v-card-title>
                            <v-card-text class="mb-2 pt-0">
                                <h4 class="card-title font-weight-medium">
                                    {{ account.name }}
                                </h4>
                                <p>
                                    {{ account.hname }}
                                </p>
                                <p>
                                    {{ account.address1 }}
                                </p>
                                <br />
                                <div class="ml-2 mt-2">
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Home Phone:
                                        </div>
                                        <div>
                                            {{ account.homePhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Cell Phone:
                                        </div>
                                        <div>
                                            {{ account.cellPhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="motherPhone"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Mother Phone:
                                        </div>
                                        <div>
                                            {{ motherPhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.emailAddress"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Email:
                                        </div>
                                        <div>
                                            {{ account.emailAddress }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.note"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Note:
                                        </div>
                                        <div>
                                            {{ account.note }}
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card-text>

                            <v-card-actions class="pl-0">
                                <v-layout row wrap>
                                    <div v-if="!editingCountry" class="pl-3">
                                        <v-layout row align-center>
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Country:
                                            </div>
                                            <div>
                                                {{ country.countryDescription }}
                                            </div>

                                            <v-btn
                                                @click="() => editCountry()"
                                                flat
                                                icon
                                                class="text-xs-right"
                                                color="success"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="!lapidusAccount.bungalow"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Bungalow:
                                            </div>
                                            <div>
                                                {{ country.bungalow }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Lunch Match Type:
                                            </div>
                                            <div
                                                v-bind:class="{
                                                    'text-info':
                                                        lapidusAccount.lunchMatchType !=
                                                        'MISSING',
                                                    'text-danger':
                                                        lapidusAccount.lunchMatchType ==
                                                        'MISSING',
                                                }"
                                            >
                                                {{
                                                    lapidusAccount.lunchMatchType
                                                        ? lapidusAccount.lunchMatchType
                                                        : "Loading..."
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="lapidusAccount.bungalow"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Bungalow:
                                            </div>
                                            <div>
                                                {{ lapidusAccount.bungalow }}
                                            </div>
                                        </v-layout>
                                        <!-- <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Lunch Doc Status:
                                            </div>
                                            <div>
                                                {{
                                                    lapidusAccount.lunchDocumentStatus
                                                }}
                                            </div>
                                        </v-layout> -->
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="
                                                lapidusAccount.lunchDocumentURL
                                            "
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Document:
                                            </div>
                                            <a
                                                :href="
                                                    lapidusAccount.lunchDocumentURL
                                                "
                                                target="_blank"
                                                class="website-link-text"
                                                >Lunch Document</a
                                            >
                                        </v-layout>
                                        <!-- <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Note:
                                            </div>
                                            <div>
                                                {{ country.note }}
                                            </div>
                                        </v-layout> -->
                                    </div>
                                    <div
                                        v-else
                                        class="px-4 pt-4 pb-2 mb-3"
                                        style="border: 2px solid #4caf50;"
                                    >
                                        <v-layout row align-center>
                                            <v-select
                                                :items="
                                                    countries.map(
                                                        (c) => c.value,
                                                    )
                                                "
                                                ref="country"
                                                label="Country"
                                                v-model="
                                                    country.countryDescription
                                                "
                                                :rules="countryRules"
                                                box
                                                hide-details
                                            >
                                            </v-select>
                                            <v-text-field
                                                class="ml-3"
                                                label="Bungalow"
                                                v-model="country.bungalow"
                                                hide-details
                                            ></v-text-field>
                                            <v-text-field
                                                ref="customCountry"
                                                class="ml-3"
                                                v-if="
                                                    country.countryDescription ==
                                                        'Other'
                                                "
                                                label="Country Name"
                                                v-model="customCountry"
                                                :rules="customCountryRules"
                                            ></v-text-field>
                                        </v-layout>
                                        <v-divider
                                            class="mb-2 mt-4"
                                        ></v-divider>
                                        <v-layout row class="pt-0">
                                            <!-- <v-radio-group
                                                v-model="lunchDocument"
                                                row
                                                hide-details
                                                class="mt-0"
                                                style="max-width: 440px;"
                                            >
                                                <v-radio
                                                    class="py-2 pr-2"
                                                    label="Lunch Document Required"
                                                    value="hasLunchDocument"
                                                    color="success"
                                                ></v-radio>
                                                <v-radio
                                                    class="py-2 pr-2"
                                                    label="Lunch Document Not Required"
                                                    value="lunchProgramIneligible"
                                                    color="success"
                                                ></v-radio>
                                            </v-radio-group> -->
                                            <v-btn
                                                small
                                                style="height: 35px;"
                                                outline
                                                class="mr-2 ml-3 mb-2 mt-2"
                                                :loading="uploading"
                                                @click="pickFile()"
                                            >
                                                Upload Document
                                                <v-icon right dark
                                                    >mdi-cloud-upload</v-icon
                                                >
                                            </v-btn>
                                            <div
                                                v-if="files.length"
                                                class="mt-3 ml-2"
                                            >
                                                {{ files[0].name }}
                                            </div>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <input
                                            type="file"
                                            style="display: none"
                                            ref="files"
                                            accept="image/*,.pdf"
                                            @change="onFilePicked($event)"
                                        />

                                        <div
                                            v-if="
                                                !lapidusAccount.lunchMatchType &&
                                                    !lunchDocumentUrl
                                            "
                                            class="ml-0 pb-3 text-danger"
                                        >
                                            Please upload the lunch document
                                        </div>
                                        <!-- <div
                                            v-if="lapidusAccount.lunchMatchType"
                                            class="ml-0 mt-3 pb-3 text-success"
                                        >
                                            Lunch Document Not Required
                                        </div> -->
                                        <v-card-actions class="mr-0">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                class="ml-2 mr-1"
                                                @click="() => rollbackCountry()"
                                                small
                                                dark
                                                color="default"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                @click="updateCountry"
                                                small
                                                color="success"
                                            >
                                                save
                                            </v-btn>
                                        </v-card-actions>
                                        <!--  <v-layout row>
                                            <v-text-field
                                                label="Note"
                                                v-model="country.note"
                                            ></v-text-field>
                                        </v-layout> -->
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-layout row justify-end class="mb-1 mr-1">
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            @click="emailCards"
                                            >Email Cards</v-btn
                                        >
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            @click="printCards"
                                            >Print Cards</v-btn
                                        >
                                        <v-btn
                                            class="mt-3 mb-2"
                                            color="info"
                                            small
                                            @click="newStudentDialog = true"
                                            >New Student</v-btn
                                        >
                                    </v-layout>
                                </v-layout>
                            </v-card-actions>
                        </v-layout>
                    </v-layout>
                </v-card>
                <transactions-list
                    :loading="transactionsLoading"
                    :transactions="transactions"
                    :immunizationsDocuments="immunizationsDocuments"
                    :account="account"
                    :lapidusAccount="lapidusAccount"
                    :refresh="load"
                    :regID="regID"
                    :currentRegID="currentRegID"
                    :country="getCountry()"
                    :openDialogForStudent="openDialogForStudent"
                    :openPaymentModal="openPaymentModal"
                    :printStatement="printStatement"
                    :openEmailStatementDialog="openEmailStatementDialog"
                    :openNewCreditCardModal="openNewCreditCardModal"
                ></transactions-list>
            </v-flex>
            <v-flex xs4 class="pa-0">
                <balance-details
                    :loading="transactionsLoading"
                    :regID="regID"
                    :total="lapidusAccount.debit"
                    :previousBalance="lapidusAccount.previousBalance"
                    :credit="lapidusAccount.credit"
                    :paid="lapidusAccount.paid"
                    :scheduledPayments="lapidusAccount.scheduledPayments"
                    :totalPaid="lapidusAccount.totalPaid"
                    :balance="lapidusAccount.balance"
                    :pastYearsEnrollmentInfo="pastYearsEnrollmentInfo"
                    :account="lapidusAccount"
                    :voucherAccount="voucherAccount"
                    :unprocessedPayments="unprocessedPayments"
                    :reload="load"
                ></balance-details>

                <payment-methods
                    :reloadPage="load"
                    :paymentMethods="paymentMethods"
                >
                </payment-methods>

                <notes
                    v-if="notesUrl"
                    :loadUrl="notesUrl"
                    :accountID="account.accountID"
                    :typeID="regID"
                    type="LAPIDUS"
                ></notes>
                <!-- <v-card
                    class="pa-3 mt-3"
                    style="border: 3px solid rgb(92, 184, 96);"
                >
                    <v-btn
                        @click="openNewCreditCardModal()"
                        small
                        class=""
                        color="success"
                        >New Credit Card</v-btn
                    >
                    <v-card-actions class="mx-0">
                        <v-btn
                            class="mr-1"
                            color="success"
                            @click="openPaymentModal"
                        >
                            Make Payment
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            outline
                            color="success"
                            small
                            @click="printStatement"
                            >Print Statement</v-btn
                        >
                        <v-btn
                            outline
                            color="success"
                            small
                            @click="openEmailStatementDialog"
                            >Email Statement</v-btn
                        >
                    </v-card-actions>
                </v-card> -->
            </v-flex>
        </v-layout>

        <v-dialog v-model="newPaymentMethodDialog" max-width="400">
            <new-payment-method
                :accountID="account.accountID"
                :closeDialog="closeNewPaymentMethodDialog"
                :onSave="load"
                :hideBankAccount="true"
            ></new-payment-method>
        </v-dialog>

        <v-dialog persistent scrollable v-model="paymentDialog" max-width="800">
            <!-- <payment
                ref="paymentDialog"
                :paymentMethods="paymentMethods"
                :closePaymentDialog="closePaymentModal"
                :account="account"
                :lapidusAccount="lapidusAccount"
                :voucherAccount="voucherAccount"
                :refresh="load"
            ></payment> -->
        </v-dialog>
        <v-dialog persistent scrollable v-model="paymentDialog" max-width="800">
            <make-payment
                ref="paymentDialog"
                :paymentMethods="paymentMethods"
                :closePaymentDialog="closePaymentModal"
                :account="account"
                :lapidusAccount="lapidusAccount"
                :voucherAccount="voucherAccount"
                :refresh="load"
                :processURL="processURL"
                :regID="regID"
                source="LAPIDUS"
                :categoryCode="isGirls ? 'LPDC' : 'LAPC'"
                :categoryDescription="
                    isGirls ? 'Lapidus Day Camp' : 'Lapidus Chider'
                "
            ></make-payment>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student>
        </v-dialog>
        <v-dialog persistent v-model="newAccountDialog" max-width="800">
            <new-account
                ref="newAccount"
                :closeNewAccountModal="closeNewAccountModal"
                :onCreated="onNewAccountCreated"
            ></new-account>
        </v-dialog>
        <v-dialog v-model="emailStatementDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Statement</v-card-title>
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailStatement"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="emailStatementDialog = false">Cancel</v-btn>
                    <v-btn
                        :loading="emailing"
                        color="success"
                        @click="emailStatement"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="printCardsDialog" max-width="400">
            <v-card class="pa-2">
                <div v-if="studentsMissingImmunizationsDocuments().length">
                    <v-card-title class="text-danger headline"
                        >Missing Immunizations</v-card-title
                    >
                    <v-card-text class="mb-2">
                        Immunizations Documents are Missing for:
                        <br />
                        {{
                            studentsMissingImmunizationsDocuments()
                                .map((t) => t.student.name)
                                .join(", ")
                        }}
                    </v-card-text>
                </div>
                <div v-else>
                    <v-card-title class="text-warning headline"
                        >Are you sure?</v-card-title
                    >
                    <v-card-text class="mb-2">
                        Lunch Documents are Missing for:
                        <br />
                        {{
                            studentsMissingLunchDocuments()
                                .map((t) => t.student.name)
                                .join(", ")
                        }}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="printCardsDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn color="success" dark @click="print">
                            Print
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="emailCardsDialog" max-width="400">
            <v-card class="pa-2">
                <div v-if="studentsMissingImmunizationsDocuments().length">
                    <v-card-title class="text-danger headline"
                        >Missing Immunizations</v-card-title
                    >
                    <v-card-text class="mb-2">
                        Immunizations Documents are Missing for:
                        <br />
                        {{
                            studentsMissingImmunizationsDocuments()
                                .map((t) => t.student.name)
                                .join(", ")
                        }}
                    </v-card-text>
                </div>
                <div v-else>
                    <div v-if="studentsMissingLunchDocuments().length">
                        <v-card-title class="text-warning headline"
                            >Are you sure?</v-card-title
                        >
                        <v-card-text class="mb-2">
                            Lunch Documents are Missing for:
                            <br />
                            {{
                                studentsMissingLunchDocuments()
                                    .map((t) => t.student.name)
                                    .join(", ")
                            }}
                        </v-card-text>
                    </div>
                    <div v-else>
                        <v-card-title class="headline"
                            >Email Cards</v-card-title
                        >
                    </div>
                    <v-text-field
                        class="px-3"
                        ref="email"
                        v-model="emailAddress"
                        :rules="emailRules"
                    ></v-text-field>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            dark
                            color="default"
                            @click="emailCardsDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            :loading="emailing"
                            color="success"
                            @click="sendEmail"
                        >
                            Send
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import { loadOptions } from "../utils/smLookup.js";
import transactionsComponent from "./LapidusDayCamp/Transactions.vue";
import payment from "./LapidusDayCamp/Payment.vue";
import schedulePayment from "./LapidusDayCamp/SchedulePayment.vue";
import newStudent from "./LapidusDayCamp/newStudent.vue";
import newAccount from "./LapidusDayCamp/newAccount.vue";
import balanceDetails from "./LapidusDayCamp/BalanceDetails.vue";
import { getDomain } from "../utils/helpers.js";
import newPaymentMethod from "./Payment/NewPaymentMethod.vue";
import paymentMethods from "./Account/PaymentMethods.vue";
import notes from "./components/Notes.vue";
import makePayment from "./Payment/MakePayment.vue";

export default {
    components: {
        balanceDetails,
        paymentMethods,
        notes,
        payment: payment,
        "make-payment": makePayment,
        "schedule-payment": schedulePayment,
        "transactions-list": transactionsComponent,
        "new-account": newAccount,
        "new-student": newStudent,
        newPaymentMethod,
    },
    data() {
        return {
            account: {},
            lapidusAccount: {},
            voucherAccount: {},
            motherPhone: "",

            transactions: [],
            phonesNumbers: [],
            classes: [],
            students: [],
            enrolledStudents: [],
            gradesSetup: [],
            pastYearsEnrollmentInfo: [],

            paymentMethods: [],
            immunizationsDocuments: [],

            unprocessedPayments: [],

            paymentDialog: false,
            newStudentDialog: false,
            newAccountDialog: false,

            transactionsLoading: true,

            country: "",
            countries: [],
            originalCountry: "",
            editingCountry: false,
            customCountry: "",

            lunchDocument: false,
            uploading: false,
            files: [],
            lunchDocumentUrl: "",

            openDialogForStudent: null,
            printCardsDialog: false,
            newPaymentMethodDialog: false,

            emailCardsDialog: false,
            emailStatementDialog: false,
            emailAddress: "",
            emailing: false,

            regID: "",
            currentRegID: "",
            processURL: "api/lapidusDayCamp/processPayment",

            countryRules: [(value) => !!value || "Required."],
            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            customCountryRules: [(value) => !!value || "Required."],

            notesUrl: "",
            isGirls: false,
        };
    },
    async created() {
        this.isGirls = this.$route.query.isGirls;

        this.load();
    },
    computed: {},
    methods: {
        async load() {
            this.transactionsLoading = true;

            await this.loadRegID();
            await this.loadVoucherAccount();
            await this.loadLapidusAccount();
            await this.loadAccount();
            await this.loadAccountPhones();
            await this.loadGradesSetup();
            await this.loadPastYearsEnrollmentInfo();
            await this.loadClasses();
            await this.loadUnprocessedPayment();
            await this.loadStudents();
            await this.loadTransctions();
            await this.loadCountries();
            await this.loadImmunizationDocuments();
            await this.loadClickedStudent();
            await this.loadLapidusStudents();

            this.loadSavedCards();
        },
        async loadRegID() {
            const regID = await this.$http.get("api/lapidusDayCamp/getRegID");

            this.currentRegID = regID;

            if (this.$route.params.reg_id) {
                this.regID = this.$route.params.reg_id;
            } else {
                this.regID = this.currentRegID;
            }

            this.notesUrl =
                "api/lapidusDayCamp/getNotes?accountID=" +
                this.$route.params.id +
                "&regID=" +
                this.regID;
        },
        async loadAccount() {
            this.account = await this.$http.get(
                "api/accounts/GetAccount?accountID=" + this.$route.params.id,
            );

            this.emailAddress = this.account.emailAddress;
        },
        async loadLapidusAccount() {
            let url =
                "api/lapidusDayCamp/GetLapidusAccount?accountID=" +
                this.$route.params.id +
                "&regID=" +
                this.regID;

            if (this.isGirls) {
                url =
                    "api/lapidusDayCamp/GetLapidusDayCampAccount?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID;
            }

            this.lapidusAccount = await this.$http.get(url);

            this.country = await this.$http.get(
                "api/lapidusDayCamp/GetLapidusAccountCountry?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID,
            );
        },
        async loadAccountPhones() {
            const phones = await this.$http.get(
                "api/accounts/getAccountPhones?accountID=" +
                    this.$route.params.id,
            );

            this.phonesNumbers = phones.filter((p) => p.phoneType == "MCEL");

            if (this.phonesNumbers.length) {
                this.motherPhone = this.phonesNumbers[0].phoneNum;
            }
        },
        async loadVoucherAccount() {
            const accountID = this.$route.query.voucherAccount
                ? this.$route.query.voucherAccount
                : this.$route.params.id;

            const voucherAccount = await this.$http.get(
                "api/lapidusTransactions/GetAccount?regID=" +
                    this.regID +
                    "&accountID=" +
                    accountID,
            );

            this.voucherAccount = voucherAccount
                ? voucherAccount
                : {
                      available: 0,
                      accountID: accountID,
                  };
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID,
            );
            this.classes = classes;
        },
        async loadUnprocessedPayment() {
            const response = await this.$http.get(
                "api/unprocessedPayments/GetForAccount?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID,
            );

            const categoryCode = this.isGirls ? "LPDC" : "LAPC";

            this.unprocessedPayments = response.filter(
                (r) => r.categoryCode.trim() == categoryCode,
            );
        },
        async loadTransctions() {
            try {
                this.transactionsLoading = true;

                const response = await this.$http.get(
                    "api/lapidusDayCamp/GetTransactions?accountID=" +
                        this.$route.params.id +
                        "&regID=" +
                        this.regID +
                        (this.isGirls ? "&categoryCode=LPDC" : ""),
                );

                const transactions = response.map((t) => {
                    t.date = t.date;
                    t.dateCreated = t.dateCreated ? t.dateCreated : null;
                    t.lastUpdated = t.lastUpdated ? t.lastUpdated : null;

                    return t;
                });

                this.enrolledStudents = await this.$http.get(
                    "api/lapidusDayCamp/GetEnrolledStudents?accountID=" +
                        this.$route.params.id +
                        "&regID=" +
                        this.regID,
                );

                const printedCards = await this.$http.get(
                    "api/lapidusDayCamp/GetPrintedCards?accountID=" +
                        this.$route.params.id +
                        "&regID=" +
                        this.regID,
                );

                const bills = transactions
                    .filter((t) => t.txnType == "D")
                    .map((transaction) => {
                        const enrollment = this.enrolledStudents.find(
                            (s) => s.id == transaction.dayCampID,
                        );

                        const student = this.students.find(
                            (s) => s.studentID == enrollment.studentID,
                        );

                        transaction.student = {
                            isEnrolled: true,
                            enrollment: enrollment,
                            studentID: enrollment.studentID,
                            cardPrinted: enrollment.cardPrintDate,
                            chosenClass: this.getClass(enrollment),
                        };

                        if (student) {
                            transaction.student.cardPrinted = printedCards.find(
                                (p) => p.studentID == student.studentID,
                            );
                            transaction.student.nonUTA = student.nonUTA;
                            transaction.student.name = student.engName;
                            transaction.student.engName = student.engName;
                            transaction.student.dob = student.dob;
                            transaction.student.studentID = student.studentID;
                            transaction.student.hebName = student.hebName;
                            transaction.student.class = student.class;
                        }

                        return transaction;
                    });

                const credits = transactions.filter((t) => t.txnType == "C");

                this.transactions = bills.concat(credits);

                this.addRunningBalance(this.transactions);

                this.transactions
                    .filter((t) => t.txnType == "C")
                    .forEach((transaction) => {
                        if (transaction.payments.length) {
                            transaction.payments.forEach(
                                (p) => (p.expanded = false),
                            );
                        }

                        if (transaction.schedules.length) {
                            transaction.schedules.forEach(
                                (p) => (p.expanded = false),
                            );
                        }
                    });

                this.transactionsLoading = false;

                // const payments = await this.$http.get(
                //     "api/lapidusDayCamp/GetPayments?accountID=" +
                //         this.$route.params.id,
                // );

                // console.log("full list", payments);

                // this.transactions.forEach((transaction) => {
                //     if (transaction.paymentLogID || transaction.scheduleDetailID) {
                //         const paymentList = transaction.paymentLogID
                //             ? payments.filter(
                //                   (p) => p.paymentID == transaction.paymentLogID,
                //               )
                //             : payments.filter(
                //                   (p) =>
                //                       p.scheduleDetailId ==
                //                       transaction.scheduleDetailID,
                //               );
                //         transaction.payment = paymentList.length
                //             ? paymentList[0]
                //             : null;
                //         transaction.payments = paymentList;

                //         console.log(transaction, paymentList);
                //     }
                // });
            } catch (e) {
                this.transactionsLoading = false;
            }
        },
        getClass(student) {
            if (student.classID == null) return "";

            return this.classes.find((c) => c.classID == student.classID);
        },
        addRunningBalance(transactions) {
            let totalBalance = 0;

            if (this.lapidusAccount.previousBalance) {
                transactions.unshift({
                    description: "Previous Balance",
                    amount: this.lapidusAccount.previousBalance,
                    calcAmount: this.lapidusAccount.previousBalance,
                    balance: this.lapidusAccount.previousBalance,
                    txnType: "D",
                    student: {
                        enrollment: {},
                    },
                });
            }

            transactions.forEach((transaction) => {
                let balance = totalBalance;

                const amount =
                    this.isError(transaction) ||
                    this.isDeclined(transaction) ||
                    this.isPastDue(transaction)
                        ? 0
                        : transaction.calcAmount;

                balance = totalBalance + amount;

                totalBalance = balance;

                transaction.balance = balance.toFixed(2);
            });
        },
        isDeclined(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "DECLINED"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "DECLINED") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status == "Declined")
            // );
        },
        isError(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "ERROR"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "ERROR") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status.startsWith("Error"))
            // );
        },
        isPastDue(transaction) {
            const today = new Date();

            if (
                this.getPaymentType(transaction) == "Cash/Check" ||
                (transaction.schedules &&
                    transaction.schedules.some((s) => s.status == "Scheduled"))
            ) {
                return (
                    new Date(transaction.date) < today &&
                    (transaction.paymentStatus == "SCHEDULED" ||
                        !transaction.receiptNumber)
                );
            }
        },
        getPaymentType(transaction) {
            if (transaction.txnType == "D") return;

            if (transaction.description.startsWith("CK")) return "ACH";

            if (transaction.description.startsWith("Country Voucher"))
                return "Country Voucher";

            return !transaction.description.includes(" ")
                ? transaction.description
                : transaction.description.substr(
                      0,
                      transaction.description.indexOf(" "),
                  );
        },
        async loadStudents() {
            const students = await this.$http.get(
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`,
            );

            this.students = students;
        },
        getPhoneType(phoneType) {
            switch (phoneType) {
                case "PHON":
                    return "Home Phone";
                case "CEL":
                    return "Cellphone";
                case "MCEL":
                    return "Mother Cellphone";
            }
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup",
            );
        },
        async loadPastYearsEnrollmentInfo() {
            const url = this.isGirls
                ? `api/lapidusDayCamp/GetDayCampEnrollmentDetailsPerYear?accountID=${
                      this.account.accountID
                  }`
                : `api/lapidusDayCamp/getEnrollmentDetailsPerYear?accountID=${
                      this.account.accountID
                  }`;

            const info = await this.$http.get(url);

            this.pastYearsEnrollmentInfo = info;
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isCountryAvail;
        },
        async loadCardHistory() {
            // this.cardHistory = await this.$http.get(
            //     "api/lapidusDayCamp/getCardHistory?accountID=" +
            //         this.account.accountID
            // );
        },
        async loadSavedCards() {
            const paymentMethods = await this.$http.get(
                "api/payments/getSavedCards?accountID=" +
                    this.account.accountID,
            );

            this.paymentMethods = paymentMethods
                .filter((p) => p.type == "CC")
                .map((method) => {
                    method.cardInfo =
                        (method.cardType ? method.cardType : "") +
                        " - " +
                        method.cardNumberLast5;

                    method.editing = false;
                    method.processing = false;

                    return method;
                })
                .sort((a, b) => {
                    if (Date.parse(a.lastUsed) > Date.parse(b.lastUsed))
                        return -1;
                    if (Date.parse(a.lastUsed) < Date.parse(b.lastUsed))
                        return 1;
                    return 0;
                });
        },
        async loadCountries() {
            this.countries = await loadOptions("country");
        },
        async loadImmunizationDocuments() {
            if (!this.account.nonUTA) {
            }

            this.immunizationsDocuments = (await this.$http.get(
                "api/lapidusDayCamp/getDocuments?accountID=" +
                    this.account.accountID,
            )).map((doc) => {
                doc.uploadedOn = moment(doc.uploadedOn).format("LLL");

                return doc;
            });
        },
        async loadLapidusStudents() {
            let students = await this.$http.get(
                "api/lapidusDayCamp/GetLapidusStudents?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID,
            );

            if (!students) return;

            students = students.filter((s) =>
                this.enrolledStudents.some(
                    (e) => s.studentID.trim() == e.studentID.trim(),
                ),
            );

            if (!students.length) return;

            this.lapidusAccount.lunchMatchType = students[0].lunchMatchType;

            if (!this.lapidusAccount.lunchMatchType) {
                this.lapidusAccount.lunchMatchType = "MISSING";
            }

            this.transactions
                .filter((t) => t.student)
                .forEach((t) => {
                    const lapidusStudent = students.find(
                        (s) => s.studentID.trim() == t.student.studentID.trim(),
                    );

                    if (lapidusStudent) {
                        t.student.lunchMatchType =
                            lapidusStudent.lunchMatchType;
                    }
                });
        },
        async loadClickedStudent() {
            if (!this.$route.query.studentID) return;

            const enrollment = this.enrolledStudents.find(
                (s) => s.studentID == this.$route.query.studentID,
            );

            const student = this.students.find(
                (s) => s.studentID == this.$route.query.studentID,
            );

            this.openDialogForStudent = {
                isEnrolled: true,
                enrollment: enrollment,
                studentID: student.studentID,
                nonUTA: student.nonUTA,
                name: student.engName,
                engName: student.engName,
                dob: student.dob,
                studentID: student.studentID,
                hebName: student.hebName,
                class: student.class,
                chosenClass: this.getClass(enrollment),
            };
        },
        getCountry() {
            if (!this.country) return "";

            return this.country.countryDescription;
        },
        editCountry() {
            this.originalCountry = this.country.countryDescription;
            this.originalBungalow = this.country.bungalow;
            this.originalNote = this.country.note;
            this.lunchDocumentUrl = this.lapidusAccount.lunchDocumentURL;
            this.lunchDocument =
                this.lapidusAccount.lunchMatchType || this.lunchDocumentUrl
                    ? "hasLunchDocument"
                    : this.lapidusAccount.lunchDocumentStatus == "INELIGIBLE"
                    ? "lunchProgramIneligible"
                    : "";
            this.editingCountry = true;
        },
        rollbackCountry() {
            this.country.countryDescription = this.originalCountry;
            this.country.bungalow = this.originalBungalow;
            this.country.note = this.originalNote;
            this.editingCountry = false;
        },
        validateCountry() {
            const validations = [this.$refs.country.validate(true)];

            if (this.country == "Other") {
                validations.push(this.$refs.customCountry.validate(true));
            }

            return validations.every(Boolean);
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/lapidusDayCamp/uploadLunchDocument?user=" +
                        this.$store.state.authentication.user +
                        "&accountID=" +
                        this.account.accountID,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.lunchDocumentUrl = response;
                this.lunchDocument = "hasLunchDocument";

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async updateCountry() {
            if (!this.validateCountry()) return;

            try {
                await this.$http.post("api/lapidusDayCamp/updateCountry", {
                    familyID: this.account.accountID,
                    countryId:
                        this.country.countryDescription != "Other"
                            ? this.countries.find(
                                  (c) =>
                                      c.value ==
                                      this.country.countryDescription,
                              ).id
                            : "",
                    countryDescription:
                        this.country.countryDescription != "Other"
                            ? this.country.countryDescription
                            : this.customCountry,
                    bungalow: this.country.bungalow,
                    note: this.country.note,
                    user: this.$store.state.authentication.user,
                    regID: this.regID,
                    lunchDocument: this.lunchDocument == "hasLunchDocument",
                    lunchDocumentURL: this.lunchDocumentUrl,
                    lunchProgramIneligible:
                        this.lunchDocument == "lunchProgramIneligible",
                });
            } catch (e) {
                this.$notify({
                    text: "An error has occurred",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.editingCountry = false;
            this.lunchDocumentUrl = "";
            this.files = [];

            if (this.country.countryDescription != this.originalCountry) {
                this.$notify({
                    text: "Please adjust pricing",
                    group: "notification",
                    type: "warning",
                    duration: 10000,
                });
            }

            this.load();
        },
        openPaymentModal({ countryVoucher = false }) {
            this.paymentDialog = true;

            if (countryVoucher) {
                const types = this.$refs.paymentDialog.getPaymentTypes();
                const type = types.find((t) =>
                    t.value.startsWith("Country Voucher"),
                );

                if (!type) return;

                this.$refs.paymentDialog.type = type.value;
                this.$refs.paymentDialog.amount = type.value.replace(/\D/g, "");
                this.$refs.paymentDialog.paymentTypeDisabled = true;
            }
        },
        closePaymentModal() {
            this.paymentDialog = false;
        },
        onNewStudentCreated() {
            this.newStudentDialog = false;

            this.load();
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        closeNewAccountModal() {
            this.newAccountDialog = false;
        },
        async editAccount() {
            const newAccountPrefill = await this.$http.get(
                "api/lapidusDayCamp/getNewAccount?accountID=" +
                    this.account.accountID,
            );

            this.$refs.newAccount.prefill(newAccountPrefill);

            this.newAccountDialog = true;
        },
        onNewAccountCreated(account) {
            this.load();
            this.loadAccountPhones();
        },
        printCards() {
            if (
                this.studentsMissingLunchDocuments().length ||
                this.studentsMissingImmunizationsDocuments().length
            ) {
                return (this.printCardsDialog = true);
            }

            this.print();
        },
        studentsMissingLunchDocuments() {
            return this.transactions.filter(
                (transaction) =>
                    transaction.txnType == "D" &&
                    (transaction.description.startsWith("Lapidus Chider") ||
                        transaction.description.startsWith(
                            "Lapidus Day Camp",
                        )) &&
                    transaction.student.enrollment.regType != "NONE" &&
                    !transaction.student.enrollment.lunchDoc,
            );
        },
        studentsMissingImmunizationsDocuments() {
            const nonUtaStudents = this.transactions.filter(
                (transaction) =>
                    transaction.txnType == "D" &&
                    (transaction.description.startsWith("Lapidus Chider") ||
                        transaction.description.startsWith(
                            "Lapidus Day Camp",
                        )) &&
                    transaction.student.nonUTA &&
                    transaction.student.enrollment.regType != "NONE",
            );

            return nonUtaStudents.filter(
                (t) =>
                    !this.immunizationsDocuments
                        .map((d) => d.studentID)
                        .includes(t.student.studentID.trim()),
            );
        },
        print() {
            window.location =
                getDomain() +
                "/api/lapidusDayCamp/downloadCards?accountID=" +
                this.account.accountID +
                (this.isGirls ? "&isGirls=true" : "");

            this.printCardsDialog = false;
        },
        emailCards() {
            this.emailCardsDialog = true;
        },
        async sendEmail() {
            if (!this.$refs.email.validate()) return;

            try {
                this.emailing = true;

                await this.$http.post(
                    "api/lapidusDayCamp/emailCards?accountID=" +
                        this.account.accountID +
                        "&emailAddress=" +
                        this.emailAddress +
                        (this.isGirls ? "&isGirls=true" : ""),
                );

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailing = false;

                this.emailCardsDialog = false;
                this.emailAddress = this.account.emailAddress;
            } catch (e) {
                this.emailing = false;
            }
        },
        getRegisteredWeeks(transaction) {
            const weeks = Object.keys(transaction.student.enrollment)
                .map((key) => {
                    if (
                        !key.startsWith("week") ||
                        !transaction.student.enrollment[key]
                    )
                        return;

                    return key.substring(4);
                })
                .filter(Boolean);

            return weeks.join(", ");
        },
        closeNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = false;
        },
        updateSelectedPaymentMethod(paymentMethod) {
            paymentMethod.cardInfo =
                paymentMethod.cardType + " - " + paymentMethod.cardNumberLast5;

            this.paymentMethods.push(paymentMethod);
        },
        createStatement() {
            let html = `<!DOCTYPE html>
            <html>
            <head>
            <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                  width: 100%;
                }

                td, th {
                  border: 1px solid #dddddd;
                  text-align: left;
                  padding: 8px;
                }
                .text-table td, table {
                    border: none;
                    padding: 0px;
                    background-color: #fff;
                }

                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                    font-weight: 200;
                    margin-bottom: 20px;
                }

                tr:nth-child(even) {
                  background-color: #dddddd;
                }
                .regular-text {
                    margin-bottom: 8px;
                    margin-top: 0px;
                }
            </style>
            </head>
            <body style="padding: 10px;">`;

            if (!this.isGirls) {
                html += `<p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong><span style="font-family: arial, helvetica, sans-serif;">ת"ת תורה ויראה דרבינו יואל מ'סאטמאר</span> </strong></span></p>`;
            } else {
                html += `<p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong><span style="font-family: arial, helvetica, sans-serif;"></span>דעי קעמפ</strong></span></p>`;
            }

            html += `<p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;"><span style="font-family: arial, helvetica, sans-serif;">שע"י סאטמאר באנגעלאו קאלאני</span></span></p>
            <p>&nbsp;</p>

            <div class="account-info">
            <p class="regular-text"><strong>${this.account.name}</strong></p>
            <p class="regular-text"><strong>Address: </strong>${
                this.account.address1
            }</p>
            <p class="regular-text"><strong>Phone: </strong>${
                this.account.homePhone
            }</p>`;

            if (this.account.emailAddress) {
                html += `<p class="regular-text"><strong>Email: </strong>${
                    this.account.emailAddress
                }</p>`;
            }

            html += `<p class="regular-text"><strong>Country: </strong>${
                this.lapidusAccount.country
            }</p>
            </div>

            <table style="border-collapse: collapse; width: 100%;" border="1">
            <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Charges</th>
                <th>Payments</th>
            </tr>
            <tbody>`;

            const transactions = JSON.parse(JSON.stringify(this.transactions));

            transactions.splice(0, 0, {
                date: moment().format("L"),
                txnType: this.lapidusAccount.previousBalance < 0 ? "C" : "D",
                description: "Previous Balance",
                calcAmount: this.lapidusAccount.previousBalance,
            });

            transactions.forEach((transaction) => {
                html += `<tr>
                    <td>${moment(transaction.date).format("L")}</td>
                    <td>${
                        transaction.txnType == "D"
                            ? (transaction.student
                                  ? transaction.student.engName
                                  : "") +
                              " - " +
                              transaction.description
                            : transaction.description
                    } ${
                    transaction.txnType == "D" &&
                    transaction.student &&
                    transaction.student.enrollment.regType == "CUSTOM"
                        ? "Weeks: " + this.getRegisteredWeeks(transaction)
                        : ""
                }</td>
                    <td><strong>${
                        transaction.txnType == "D"
                            ? transaction.calcAmount
                            : "0"
                    }</strong></td>
                    <td><strong>${
                        transaction.txnType == "C"
                            ? transaction.calcAmount
                            : "0"
                    }</strong></td>
                </tr>`;
            });

            html += `</tbody></table>
                <p>&nbsp;</p>
                <table class="text-table" style="width: 30%; margin-right: 10px;" align="right">
                <tr>
                <td><p class="regular-text">Previous Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.lapidusAccount.previousBalance
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Billed:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.lapidusAccount.debit
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Paid:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.lapidusAccount.paid
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Total Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.lapidusAccount.balance
                    }</strong></p></td>
                </tr>
                </table>

                </body>
            </html>`;

            return html;
        },
        printStatement() {
            const newWindow = window.open(
                "",
                "Account Statement",
                "width=800, height=800",
            );

            newWindow.document.write(this.createStatement());
        },
        openEmailStatementDialog() {
            this.emailStatementDialog = true;
        },
        openNewCreditCardModal() {
            this.newPaymentMethodDialog = true;
        },
        async emailStatement() {
            if (!this.$refs.emailStatement.validate(true)) return;

            this.emailing = true;

            try {
                await this.$http.post("api/lapidusDayCamp/emailLetter", {
                    emailAddress: this.emailAddress,
                    html: this.createStatement(),
                    subject: this.isGirls
                        ? "Lapidus Day Camp Statement"
                        : "Lapidus Cheider Statement",
                    emailFrom: this.isGirls ? "Lapidus Day Camp" : null,
                });

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailStatementDialog = false;
            } catch (e) {
            } finally {
                this.emailing = false;
            }
        },
        isBigScreenSize() {
            return window.innerWidth > 1400;
        },
    },
};
</script>
